import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ObjectActions from './grant-state-to-children.actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as LogbookAppReducer from '../logbook.reducer';
import * as AppActions from '../app/actions';
import {
  IBulkResponseRecord,
  IGetManyResponse,
  IGetOneResponse,
} from '../../shared/model/interface/crud-response-interface.model';
import { GrantStateToChildrenService } from './grant-state-to-children.service';
import {
  IChildrenOfSelectedLogbooks,
  IGrantStateRecordData,
} from './grant-state-to-children.model';

@Injectable()
export class GrantStateToChildrenEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<LogbookAppReducer.LogbookAppState>,
    private readonly grantStateToChildrenService: GrantStateToChildrenService,
  ) {}

  getChildrenOfSelectedLogbook = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.GET_CHILDREN_OF_SELECTED_LOGBOOK),
      switchMap((payload: ObjectActions.GetChildrenOfSelectedLogbook) => {
        this.store.dispatch(new AppActions.ShowLoader());

        return this.grantStateToChildrenService
          .getChildrenOfSelectedLogbooksData(payload.logbookId, payload.issuerAndReason)
          .pipe(
            switchMap((response: IGetManyResponse<IChildrenOfSelectedLogbooks>) => {
              return of(new ObjectActions.GetChildrenOfSelectedLogbookCompleted(response), new AppActions.HideLoader());
            }),
            catchError((errorRes) => {
              return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
            }),
          );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );

  grantStateToChildrenOfSelectedLogbook = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.GRANT_STATE_TO_CHILDREN_OF_SELECTED_LOGBOOK),
      switchMap((payload: ObjectActions.GrantStateToChildrenOfSelectedLogbook) => {
        this.store.dispatch(new AppActions.ShowLoader());

        return this.grantStateToChildrenService
          .grantStateToChildrenOfSelectedLogbook(
            payload.params.currentLogbookId,
            payload.params.childLogbookIds,
            payload.issuerAndReason,
          )
          .pipe(
            switchMap((response: IBulkResponseRecord<IGetOneResponse<IGrantStateRecordData>>) => {
              return of(new ObjectActions.GrantStateToChildrenOfSelectedLogbookCompleted(response));
            }),
            catchError((errorRes) => {
              return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
            }),
          );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );
}
